
/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareEntity({
    entity: "scenarioDefVersions",
    graphQL: "ScenarioDefVersion",
    name: "Scenario Definition Version",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    defaultOrder: [['createdAt', 'DESC']],
    optimizeReading: true,
    fields: (types) => { return {
        id: {
            name: "Scenario Definition Version ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            isPublic: true,
            required: true,
            userEditable: false,
        },
        scenarioDef: {
            name: "Scenario Definition",
            to: () => types['scenarioDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            hiddenCreate: true,
        },
        description: {
            name: "Change Description",
            type: "text",
            defaultValue: "",
        },
        gitTag: {
            name: "Git sha",
            type: "string",
        },
        gitAuthorName: {
            name: "Git Author Name",
            type: "string",
        },
        gitAuthorEmail: {
            name: "Git Author e-mail",
            type: "string",
        },
        scenarioDefContent: {
            name: "Content",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        scenarioDefContentGit: {
            name: "Content (GIT)",
            type: "object",
            permission: Permission.PERM_INSTANCE_DEVELOPER,
            import: false,
            offload: true,
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        changeAuthor: {
            name: "Last change author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
